import React from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import AdminShiftTableContent from "./AdminShiftTableContent"




const AdminShift: React.FC = () => {

  document.title = "Shifts | Zulu Courier"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Shifts" breadcrumbItem="Create Bulk Request" />
        <AdminShiftTableContent />
      </div>
    </div>
  )
}

export default AdminShift;
